import { FC } from 'react'

const FilterSelectionIcon: FC = () => (
  <svg
    width="17"
    height="22"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8.5"
      cy="10.5"
      r="8.5"
      fill="#62BFAD"
    />
    <path
      d="M9.27148 6.42188V15H8.1875V7.77539L6.00195 8.57227V7.59375L9.10156 6.42188H9.27148Z"
      fill="white"
    />
  </svg>

)

export default FilterSelectionIcon
